import { FC } from 'react';
import { LightbulbIcon } from '@phosphor-icons/react';
import { IInsightItem } from '../../../models/injury';
import styles from './AthleteInjuryCharts.module.scss';

interface InsightsCardProps {
  insights: IInsightItem[];
}

const TYPE_COLOR: Record<IInsightItem['type'], string> = {
  positive: 'var(--c-success)',
  warning: 'var(--c-warning)',
  negative: 'var(--c-error)',
  neutral: 'var(--c-text-1)',
};

export const InsightsCard: FC<InsightsCardProps> = ({ insights }) => {
  if (!insights || insights.length === 0) return null;

  return (
    <div className={styles.insightsCard}>
      <div className={styles.insightsHeader}>
        <LightbulbIcon size={18} color="var(--c-warning)" weight="fill" />
        <span className={styles.insightsTitle}>Insights clinici</span>
      </div>
      <div className={styles.insightsList}>
        {insights.map((item, i) => {
          const color = TYPE_COLOR[item.type] ?? TYPE_COLOR.neutral;
          return (
            <div key={item.key ?? i} className={styles.insightsItem}>
              <LightbulbIcon size={14} color={color} className={styles.insightsItemIcon} />
              <span className={styles.insightsItemLabel}>{item.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
